// src/components/common/Modal.jsx
// -----------------------------------------------------------------------------
// Generic modal dialog used across the app for "Add/Edit" forms (Users,
// Projects, Tickets, Roles, etc). Keeps every page's popup styled the same.
//
// Usage:
//   <Modal title="Add User" onClose={() => setOpen(false)}>
//     <form>...</form>
//   </Modal>
// -----------------------------------------------------------------------------
import PropTypes from 'prop-types';
import './common.css';

export default function Modal({ title, children, footer, onClose, size = 'medium' }) {
  const sizeClass = size === 'large' ? 'modal-lg' : size === 'small' ? 'modal-sm' : 'modal-md';

  return (
    <div className="modal-overlay">
      {/* stopPropagation so clicking inside the box doesn't close the modal */}
      <div className={`modal-box ${sizeClass}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};